import { render, staticRenderFns } from "./ProcedureInfo.vue?vue&type=template&id=3a1dff4c&"
import script from "./ProcedureInfo.vue?vue&type=script&lang=js&"
export * from "./ProcedureInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureInfo.vue?vue&type=style&index=0&rel=stylesheet%2Fless&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports